
































import Vue from 'vue';

import { BUTTON_COLORS } from '../../config';

export default Vue.extend({
  name: 'MenuNavigation',

  props: {
    disableMap: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    buttonColors: BUTTON_COLORS,
  }),

  methods: {
    back() {
      this.$emit('back');
    },

    map() {
      this.$emit('map');
    },
  },
});
